import React, { Component } from 'react'
import styled from 'styled-components'

const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin-right: 10px;
  margin-left: 10px;
  input{display:none;}
  & input:checked + span {
    background-color: #2196F3;
  }
  & input:focus + span {
    box-shadow: 0 0 1px #2196F3;
  }
  & input:checked + span:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    @media (max-width: 763px) {
      -webkit-transform: translateX(10px);
      -ms-transform: translateX(10px);
      transform: translateX(10px);
    }
  }
  @media (max-width: 763px) {
    width: 28px;
    height: 15px;
    margin-right: 5px;
    margin-left: 5px;
  }
`
const Span = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;
  &:before{
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 0px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
    @media (max-width: 763px) {
      height: 13px;
      width: 13px;
      bottom: 1px;
    }
  }

`


const Switch = props => (
  <Label >
    <input type="checkbox" onClick={props.onSwitchClick} checked={props.checked} id={props.id} />
    <Span />
  </Label>
)

export default Switch



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/Switch.jsx